import React from 'react';
import { motion } from 'framer-motion';

export const ProfessorSimo = ({ size = 'md', speaking = false, className = '' }) => {
  const sizes = {
    sm: 'w-12 h-12',
    md: 'w-20 h-20',
    lg: 'w-32 h-32',
    xl: 'w-48 h-48',
  };

  return (
    <motion.div 
      className={`relative ${sizes[size]} ${className}`}
      animate={speaking ? { scale: [1, 1.05, 1] } : {}}
      transition={{ repeat: speaking ? Infinity : 0, duration: 0.5 }}
    >
      <svg viewBox="0 0 200 200" className="w-full h-full">
        {/* Background circle with glow */}
        <defs>
          <radialGradient id="glowGradient" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="#6366F1" stopOpacity="0.3"/>
            <stop offset="100%" stopColor="#6366F1" stopOpacity="0"/>
          </radialGradient>
          <linearGradient id="beretGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#1e1b4b"/>
            <stop offset="100%" stopColor="#312e81"/>
          </linearGradient>
          <linearGradient id="faceGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#a855f7"/>
            <stop offset="50%" stopColor="#6366f1"/>
            <stop offset="100%" stopColor="#3b82f6"/>
          </linearGradient>
        </defs>
        
        {/* Glow effect */}
        <circle cx="100" cy="100" r="95" fill="url(#glowGradient)"/>
        
        {/* Main face - abstract geometric shape */}
        <motion.g
          animate={speaking ? { y: [0, -2, 0] } : {}}
          transition={{ repeat: speaking ? Infinity : 0, duration: 0.3 }}
        >
          {/* Face base - rounded square with gradient */}
          <rect 
            x="45" y="60" 
            width="110" height="100" 
            rx="35" 
            fill="url(#faceGradient)"
            className="drop-shadow-lg"
          />
          
          {/* Kangol beret */}
          <ellipse cx="100" cy="55" rx="55" ry="20" fill="url(#beretGradient)"/>
          <path 
            d="M45 55 Q100 30 155 55" 
            fill="url(#beretGradient)"
            stroke="#4c1d95"
            strokeWidth="2"
          />
          {/* Beret top button */}
          <circle cx="100" cy="38" r="5" fill="#84CC16"/>
          
          {/* Left eye - geometric */}
          <g transform="translate(65, 95)">
            <motion.circle 
              r="15" 
              fill="#0f172a"
              animate={speaking ? { scaleY: [1, 0.8, 1] } : {}}
              transition={{ repeat: speaking ? Infinity : 0, duration: 0.5 }}
            />
            <circle r="8" fill="#84CC16" cy="-2"/>
            <circle r="3" fill="white" cx="-3" cy="-5"/>
          </g>
          
          {/* Right eye - geometric */}
          <g transform="translate(135, 95)">
            <motion.circle 
              r="15" 
              fill="#0f172a"
              animate={speaking ? { scaleY: [1, 0.8, 1] } : {}}
              transition={{ repeat: speaking ? Infinity : 0, duration: 0.5 }}
            />
            <circle r="8" fill="#84CC16" cy="-2"/>
            <circle r="3" fill="white" cx="-3" cy="-5"/>
          </g>
          
          {/* Nose - small triangle */}
          <path d="M100 110 L95 125 L105 125 Z" fill="#4c1d95" opacity="0.5"/>
          
          {/* Mouth */}
          <motion.path
            d={speaking ? "M75 140 Q100 160 125 140" : "M80 140 Q100 150 120 140"}
            fill="none"
            stroke="#0f172a"
            strokeWidth="4"
            strokeLinecap="round"
            animate={speaking ? { d: ["M75 140 Q100 155 125 140", "M75 140 Q100 165 125 140", "M75 140 Q100 155 125 140"] } : {}}
            transition={{ repeat: speaking ? Infinity : 0, duration: 0.3 }}
          />
          
          {/* Neural network decoration on face */}
          <circle cx="55" cy="115" r="3" fill="#84CC16" opacity="0.6"/>
          <circle cx="145" cy="115" r="3" fill="#84CC16" opacity="0.6"/>
          <line x1="55" y1="115" x2="65" y2="95" stroke="#84CC16" strokeWidth="1" opacity="0.4"/>
          <line x1="145" y1="115" x2="135" y2="95" stroke="#84CC16" strokeWidth="1" opacity="0.4"/>
        </motion.g>
        
        {/* Floating brain particles */}
        <motion.circle 
          cx="30" cy="80" r="4" 
          fill="#84CC16"
          animate={{ y: [0, -10, 0], opacity: [0.3, 0.8, 0.3] }}
          transition={{ repeat: Infinity, duration: 2, delay: 0 }}
        />
        <motion.circle 
          cx="170" cy="90" r="3" 
          fill="#6366F1"
          animate={{ y: [0, -8, 0], opacity: [0.3, 0.8, 0.3] }}
          transition={{ repeat: Infinity, duration: 2.5, delay: 0.5 }}
        />
        <motion.circle 
          cx="40" cy="150" r="3" 
          fill="#a855f7"
          animate={{ y: [0, -6, 0], opacity: [0.3, 0.8, 0.3] }}
          transition={{ repeat: Infinity, duration: 1.8, delay: 0.3 }}
        />
        <motion.circle 
          cx="160" cy="160" r="4" 
          fill="#84CC16"
          animate={{ y: [0, -12, 0], opacity: [0.3, 0.8, 0.3] }}
          transition={{ repeat: Infinity, duration: 2.2, delay: 0.7 }}
        />
      </svg>
    </motion.div>
  );
};

export default ProfessorSimo;
